import * as React from "react";
import type { SVGProps } from "react";
const SvgDocuments = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.5 18h1a3 3 0 0 0 3-3V8a1 1 0 0 0-.29-.71l-5-5a1 1 0 0 0-.707-.29H10.5a3 3 0 0 0-3 3v1h-1a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h7a3 3 0 0 0 3-3zm-2 0h-4a3 3 0 0 1-3-3V8h-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h7a1 1 0 0 0 1-1zm.994-2H10.5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h3v3a2 2 0 0 0 2 2h3v6a1 1 0 0 1-1 1h-2.006M15.5 5.41 17.09 7H15.5z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgDocuments;
